<template>
  <div :style="'height: 100%; background: ' + backgroundColor">
    <v-row v-if="showDataSummary" justify="center">
      <v-col
        cols="10"
        class="mt-5 data-summary-flex data-summary-top justify-center"
      >
        <v-col cols="12" sm="6" md="4" class="mr-4">
          <v-card>
            <v-card-title class="text-h5 data-summary-title">
              ORDERS
            </v-card-title>
            <v-divider class="data-summary-border"></v-divider>
            <v-card-text>
              <v-col cols="10" class="mt-5 justify-center data-summary-flex">
                <v-col cols="4" sm="4" md="4" class="bigNumber">
                  {{ formatToInteger(ordersNumber) }}
                </v-col>
                <v-col cols="8" sm="8" md="8">
                  <div class="bigText">Placed Total</div>
                  <div class="smallText">&nbsp;</div>
                </v-col>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="mx-2">
          <v-card>
            <v-card-title class="text-h5 data-summary-title">
              COUNTDOWN
            </v-card-title>
            <v-divider class="data-summary-border"></v-divider>
            <v-card-text>
              <v-col cols="10" class="mt-5 justify-center data-summary-flex">
                <v-col cols="4" sm="4" md="4" class="bigNumber">
                  {{ formatToInteger(countdownNumber) }}
                </v-col>
                <v-col cols="8" sm="8" md="8">
                  <div class="bigText">Days until</div>
                  <div class="smallText">Store close</div>
                </v-col>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="ml-4">
          <v-card>
            <v-card-title class="text-h5 data-summary-title">
              ACTIVITY
            </v-card-title>
            <v-divider class="data-summary-border"></v-divider>
            <v-card-text>
              <v-col cols="10" class="mt-5 justify-center data-summary-flex">
                <v-col cols="4" sm="4" md="4" class="bigNumber">
                  {{ formatToInteger(activityNumber) }}
                </v-col>
                <v-col cols="8" sm="8" md="8">
                  <div class="bigText">New orders</div>
                  <div class="smallText">in last 24 hours</div>
                </v-col>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-col>
    </v-row>

    <report-builder
      ref="reportBuilder"
      :report-slug="reportSlug"
      :preSelectedCampaign="preSelectedCampaign"
      @submit="handleReportBuilderSubmit"
      @changeCampaign="changeCampaign"
      :backgroundColor="backgroundColor"
      :hideReportBuilderInfo="hideReportBuilderInfo"
    />
    <v-container>
      <report-dialog
        v-if="campaign"
        ref="report-dialog"
        :campaign="campaign"
        :report="report"
        :reportName="reportName"
        :selectedReportInfo="selectedReportInfo"
        :selectedBatchId="selectedBatchId"
        @submit="handleReportBuilderSubmit"
        :backgroundColor="backgroundColor"
        :hideTableHeaders="reportName != 'Orders Itemized'"
      />
    </v-container>
  </div>
</template>

<script>
import ReportBuilder from "./ReportBuilder";
// import ReportLayout from "./ReportLayout";
import ReportDialog from "./ReportDialog";
import { saveAs } from "file-saver";
import XLSXStyle from "xlsx-js-style";

export default {
  props: {
    preSelectedCampaign: {
      type: Object,
      default: null,
    },
    showDataSummary: {
      type: Boolean,
      default: false,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "#FFFFFF",
    },
    hideReportBuilderInfo: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    "report-builder": ReportBuilder,
    "report-dialog": ReportDialog,
  },

  data() {
    return {
      report: [],
      reportName: null,
      reportSlug: null,
      campaign: null,

      ordersNumber: "-",
      countdownNumber: "-",
      activityNumber: "-",

      selectedReportInfo: {},
      campaignBatchList: [],
      selectedBatchId: null,
    };
  },

  mounted() {
    this.$store.state.title = "";
    this.$store.state.topTitle = true;
    if (this.$route.query.report) {
      this.reportSlug = this.$route.query.report;
    }
  },

  watch: {
    "$route.query.report": function(newVal, oldVal) {
      if (this.report) {
        this.campaign = null;
        this.report = null;
        this.reportName = null;
      }

      this.reportSlug = newVal;
    },
  },

  methods: {
    //this is here so campaignAddEdit has a method to call
    validateTab() {
      return !this.valid;
    },
    async changeCampaign(selCampaign) {
      let res = await this.$axios.get(`/reports/datasummary/${selCampaign.id}`);
      if (res.data.result) {
        this.ordersNumber = res.data.result.orders;
        this.countdownNumber = res.data.result.countdown;
        this.activityNumber = res.data.result.activity;
      }
    },

    async fetchReport(reportSlug, campaignId, reportFormat, reportName) {
      let report = await this.$axios.get(
        `/reports/${reportSlug}/${campaignId}/${reportFormat}/${reportName}/${this.selectedBatchId}`
      );
      return report;
    },

    async fetchReportList(reportSlug, campaignId) {
      let reportList = await this.$axios.get(
        `/reports/list/${reportSlug}/${campaignId}/${this.selectedBatchId}`
      );
      return reportList;
    },

    async handleReportBuilderSubmit(
      selectedStore,
      selectedReport,
      availableReports,
      reportFormat,
      selectedReportInfo,
      selectedBatchId
    ) {
      this.campaign = selectedStore;
      this.reportName = selectedReport.name;
      this.reportSlug = selectedReport.slug;
      this.selectedReportInfo = selectedReportInfo;
      this.selectedBatchId = selectedBatchId;
      if (reportFormat === "web") {
        let report = await this.fetchReport(
          selectedReport.slug,
          selectedStore.id,
          "json",
          null
        );

        this.report = report.data;
        this.$refs["report-dialog"].show();
      } else if (reportFormat === "xlsx") {
        // export Excel file for Supplier PO’s by Decoration/Customization
        let report = await this.fetchReport(
          selectedReport.slug,
          selectedStore._jv.id,
          "json",
          null
        );
        const workbook = XLSXStyle.utils.book_new();
        // Loop through each table and create a worksheet
        report.data.forEach((table, index) => {
          let sheet_info = [[table.name]];
          sheet_info.push([table.tableDesc]);
          if (table.metadata.Decorators) {
            sheet_info.push([
              "Decorators: " + table.metadata.Decorators.join("; "),
            ]);
          }
          sheet_info.push(["Store Name: " + this.campaign.name]);
          sheet_info.push(["Distributor PO# " + this.campaign.distributor_po]);
          sheet_info.push(table.columns);
          const rows = table.rows.map((obj) =>
            table.columns.map((key) => (obj[key] ? obj[key] : ""))
          );
          sheet_info = sheet_info.concat(rows);
          const worksheet = XLSXStyle.utils.aoa_to_sheet(sheet_info);

          // Merge Cells:
          const maxCellWidth = table.columns.length - 1;
          const mergeRanges = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: maxCellWidth } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: maxCellWidth } },
            { s: { r: 2, c: 0 }, e: { r: 2, c: maxCellWidth } },
            { s: { r: 3, c: 0 }, e: { r: 3, c: maxCellWidth } },
            { s: { r: 4, c: 0 }, e: { r: 4, c: maxCellWidth } },
          ];
          const merges = worksheet["!merges"] || [];
          merges.push(...mergeRanges);
          worksheet["!merges"] = merges;

          // Apply cell styling
          const tableHeaderStyle = {
            font: {
              color: { rgb: "000000" },
              bold: true,
            },
            border: {
              top: {
                style: "thin",
                color: { rgb: "000000" },
              },
            },
          };
          const tableItemStyle = {
            fill: {
              fgColor: { rgb: "DCDCDC" },
            },
            border: {
              right: {
                style: "thin",
                color: { rgb: "000000" },
              },
              bottom: {
                style: "thin",
                color: { rgb: "D4D4D4" },
              },
            },
          };
          const headerRange = XLSXStyle.utils.decode_range("A6:H6");
          for (let row = headerRange.s.r; row <= headerRange.e.r; row++) {
            for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
              const cellAddress = XLSXStyle.utils.encode_cell({
                r: row,
                c: col,
              });
              worksheet[cellAddress].s = tableHeaderStyle;
            }
          }
          const itemRange = XLSXStyle.utils.decode_range(
            "A6:A" + (rows.length + 6).toString()
          );
          for (let row = itemRange.s.r; row <= itemRange.e.r; row++) {
            for (let col = itemRange.s.c; col <= itemRange.e.c; col++) {
              const cellAddress = XLSXStyle.utils.encode_cell({
                r: row,
                c: col,
              });
              worksheet[cellAddress].s = tableItemStyle;
            }
          }
          const a6Range = XLSXStyle.utils.decode_range("A6:A6");
          const a6Style = {
            fill: {
              fgColor: { rgb: "DCDCDC" },
            },
            font: {
              color: { rgb: "000000" },
              bold: true,
            },
            border: {
              top: {
                style: "thin",
                color: { rgb: "000000" },
              },
              right: {
                style: "thin",
                color: { rgb: "000000" },
              },
              bottom: {
                style: "thin",
                color: { rgb: "D4D4D4" },
              },
            },
          };
          for (let row = a6Range.s.r; row <= a6Range.e.r; row++) {
            for (let col = a6Range.s.c; col <= a6Range.e.c; col++) {
              const cellAddress = XLSXStyle.utils.encode_cell({
                r: row,
                c: col,
              });
              worksheet[cellAddress].s = a6Style;
            }
          }

          // Loop through the cells in the worksheet to calculate and set the optimal width
          const range = XLSXStyle.utils.decode_range(
            "A6:H" + (rows.length + 6).toString()
          );
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSXStyle.utils.encode_cell({
              r: range.s.r,
              c: C,
            });
            const cell = worksheet[cellAddress];

            // Calculate the width based on the content length
            let maxLength = 0;
            if (cell && cell.v) {
              const cellValue = cell.v.toString();
              maxLength = Math.max(maxLength, cellValue.length);
            }

            // Set the width for the column
            const columnWidth =
              maxLength > 0 ? Math.floor((maxLength + 2) * 1.25) : 10;
            worksheet["!cols"] = worksheet["!cols"] || [];
            worksheet["!cols"][C] = { wch: columnWidth };
          }
          // Add the worksheet to the workbook
          XLSXStyle.utils.book_append_sheet(
            workbook,
            worksheet,
            `${table.name} - ${index + 1}`
          );
        });

        // Convert the workbook to binary data
        const excelBuffer = XLSXStyle.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });

        // Create a Blob from the binary data
        const blob = new Blob([excelBuffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Save the Blob as a file using FileSaver.js
        saveAs(
          blob,
          `${this.campaign.name} - Production PO's - (PO's by Decoration).xlsx`
        );
      } else if (reportFormat === "csv") {
        // get report list to export as csv files
        let reportList = await this.fetchReportList(
          selectedReport.slug,
          selectedStore.id
        );
        // export csv files with report list
        if (
          selectedReport.slug == "decorator_po" ||
          selectedReport.slug == "supplier_po" ||
          selectedReport.slug == "itemized_shopper" ||
          selectedReport.slug == "creditcard_po" ||
          selectedReport.slug == "decorator_by_design" ||
          selectedReport.slug == "sales_breakdown" ||
          selectedReport.slug == "sales_tax"
        ) {
          let i;
          for (i = 0; i < reportList.data.length; i++) {
            let report = await this.fetchReport(
              selectedReport.slug,
              selectedStore.id,
              "csv",
              i
            );
            if (
              selectedReport.slug == "itemized_shopper" ||
              selectedReport.slug == "creditcard_po" ||
              selectedReport.slug == "sales_breakdown" ||
              selectedReport.slug == "sales_tax"
            ) {
              this.download(
                report.data,
                `${this.campaign.name} - ${reportList.data[i]}.csv`,
                "text/csv"
              );
            } else {
              this.download(
                report.data,
                `${this.campaign.name} - Production PO's - (PO's by Decoration) - ${reportList.data[i]}.csv`,
                "text/csv"
              );
            }
          }
        } else {
          for (var i = 0; i < reportList.data.length; i++) {
            let res = availableReports.find(function(report) {
              return report.name == reportList.data[i];
            });
            if (res && res.slug) {
              let slug = res.slug;
              let report = await this.fetchReport(
                slug,
                selectedStore.id,
                "csv",
                reportList.data[i]
              );
              if (this.campaign.distributor_po) {
                this.download(
                  report.data,
                  `${this.campaign.distributor_po} - ${this.campaign.name} - ${reportList.data[i]}.csv`,
                  "text/csv"
                );
              } else {
                this.download(
                  report.data,
                  `${this.campaign.name} - ${reportList.data[i]}.csv`,
                  "text/csv"
                );
              }
            } else {
              // if All Reports are exported, export individual Decorator Po and Supplier Po
              let slug;
              if (reportList.data[i].includes("Decorator/Customizer PO’s")) {
                slug = "decorator_po";
              } else if (
                reportList.data[i].includes("Consolidated Supplier PO")
              ) {
                slug = "supplier_po";
              } else if (reportList.data[i].includes("Orders Itemized")) {
                slug = "itemized_shopper";
              } else if (reportList.data[i].includes("Sales Breakdown")) {
                slug = "sales_breakdown";
              } else if (reportList.data[i].includes("Sales Tax (")) {
                slug = "sales_tax";
              } else if (reportList.data[i].includes("Credit Card")) {
                slug = "creditcard_po";
              } else if (
                reportList.data[i].includes(
                  "Production PO's - (PO's by Decoration)"
                )
              ) {
                slug = "decorator_by_design";
              }
              if (
                slug == "decorator_po" ||
                slug == "supplier_po" ||
                slug == "itemized_shopper" ||
                slug == "creditcard_po" ||
                slug == "decorator_by_design" ||
                slug == "sales_breakdown" ||
                slug == "sales_tax"
              ) {
                let missingReportList = await this.fetchReportList(
                  slug,
                  selectedStore.id
                );
                let j;
                for (j = 0; j < missingReportList.data.length; j++) {
                  if (missingReportList.data[j] == reportList.data[i]) {
                    let report = await this.fetchReport(
                      slug,
                      selectedStore.id,
                      "csv",
                      j
                    );
                    if (
                      selectedReport.slug == "itemized_shopper" ||
                      selectedReport.slug == "creditcard_po" ||
                      selectedReport.slug == "sales_breakdown" ||
                      selectedReport.slug == "campaign_summary" ||
                      selectedReport.slug == "sales_tax"
                    ) {
                      this.download(
                        report.data,
                        `${this.campaign.name} - ${reportList.data[i]}.csv`,
                        "text/csv"
                      );
                    } else {
                      this.download(
                        report.data,
                        `${this.campaign.name} - Production PO's - (PO's by Decoration) - ${reportList.data[i]}.csv`,
                        "text/csv"
                      );
                    }
                  }
                }
              }
            }
          }
        }
      } else if (reportFormat === "pdf") {
        // get report list to export as pdf files
        let reportList = await this.fetchReportList(
          selectedReport.slug,
          selectedStore.id
        );
        // export pdf files with report list
        if (
          selectedReport.slug == "decorator_po" ||
          selectedReport.slug == "supplier_po" ||
          selectedReport.slug == "itemized_shopper" ||
          selectedReport.slug == "creditcard_po" ||
          selectedReport.slug == "decorator_by_design" ||
          selectedReport.slug == "sales_breakdown" ||
          selectedReport.slug == "sales_tax"
        ) {
          let i;
          for (i = 0; i < reportList.data.length; i++) {
            let report = await this.fetchReport(
              selectedReport.slug,
              selectedStore.id,
              "pdf",
              i
            );
            if (
              selectedReport.slug == "itemized_shopper" ||
              selectedReport.slug == "creditcard_po" ||
              selectedReport.slug == "sales_breakdown" ||
              selectedReport.slug == "sales_tax"
            ) {
              this.download(
                report.data,
                `${this.campaign.name} - ${reportList.data[i]}.pdf`,
                "application/pdf"
              );
            } else {
              this.download(
                report.data,
                `${this.campaign.name} - Production PO's - (PO's by Decoration) - ${reportList.data[i]}.pdf`,
                "application/pdf"
              );
            }
          }
        } else {
          for (var i = 0; i < reportList.data.length; i++) {
            let res = availableReports.find(function(report) {
              return report.name == reportList.data[i];
            });
            if (res && res.slug) {
              let slug = res.slug;
              let report = await this.fetchReport(
                slug,
                selectedStore.id,
                "pdf",
                reportList.data[i]
              );
              if (this.campaign.distributor_po) {
                this.download(
                  report.data,
                  `${this.campaign.distributor_po} - ${this.campaign.name} - ${reportList.data[i]}.pdf`,
                  "application/pdf"
                );
              } else {
                this.download(
                  report.data,
                  `${this.campaign.name} - ${reportList.data[i]}.pdf`,
                  "application/pdf"
                );
              }
            } else {
              // if All Reports are exported, export individual Decorator Po and Supplier Po
              let slug;
              if (reportList.data[i].includes("Decorator/Customizer PO’s")) {
                slug = "decorator_po";
              } else if (
                reportList.data[i].includes("Consolidated Supplier PO")
              ) {
                slug = "supplier_po";
              } else if (reportList.data[i].includes("Orders Itemized")) {
                slug = "itemized_shopper";
              } else if (reportList.data[i].includes("Sales Breakdown")) {
                slug = "sales_breakdown";
              } else if (reportList.data[i].includes("Sales Tax (")) {
                slug = "sales_tax";
              } else if (reportList.data[i].includes("Credit Card")) {
                slug = "creditcard_po";
              } else if (
                reportList.data[i].includes(
                  "Production PO's - (PO's by Decoration)"
                )
              ) {
                slug = "decorator_by_design";
              }
              if (
                slug == "decorator_po" ||
                slug == "supplier_po" ||
                slug == "itemized_shopper" ||
                slug == "creditcard_po" ||
                slug == "decorator_by_design" ||
                slug == "sales_breakdown" ||
                slug == "sales_tax"
              ) {
                let missingReportList = await this.fetchReportList(
                  slug,
                  selectedStore.id
                );
                let j;
                for (j = 0; j < missingReportList.data.length; j++) {
                  if (missingReportList.data[j] == reportList.data[i]) {
                    let report = await this.fetchReport(
                      slug,
                      selectedStore.id,
                      "pdf",
                      j
                    );
                    if (
                      selectedReport.slug == "itemized_shopper" ||
                      selectedReport.slug == "creditcard_po" ||
                      selectedReport.slug == "sales_breakdown" ||
                      selectedReport.slug == "campaign_summary" ||
                      selectedReport.slug == "sales_tax"
                    ) {
                      this.download(
                        report.data,
                        `${this.campaign.name} - ${reportList.data[i]}.pdf`,
                        "application/pdf"
                      );
                    } else {
                      this.download(
                        report.data,
                        `${this.campaign.name} - Production PO's - (PO's by Decoration) - ${reportList.data[i]}.pdf`,
                        "application/pdf"
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }

      this.$refs["reportBuilder"].generatingReport = false;
    },

    download(content, filename, contentType) {
      if (!contentType) {
        contentType = "application/octet-stream";
      }

      let a = document.createElement("a");
      let blob = new Blob([content], { type: contentType });

      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      a.click();
    },

    backToReport() {
      this.report = null;
    },

    formatToInteger(value) {
      if (value === "-" || value === null || value === undefined) return "-";
      if (value == "-0") return "0";
      const n = parseInt(value);
      return isNaN(n) ? "-" : n;
    },
  },
};
</script>

<style scoped>
.data-summary-flex {
  display: flex;
  margin: 0px !important;
}

.data-summary-top {
  margin-top: 48px !important;
}

.data-summary-title {
  font-size: 18px !important;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 5px;
}
.bigNumber {
  color: red;
  font-size: 50px;
  font-weight: 600;
}
.bigText {
  font-size: 24px;
  padding-top: 10px;
}
.data-summary-border {
  border-color: red;
  border-width: 1.5px;
}

@media only screen and (max-width: 767px) {
  .data-summary-top {
    display: block;
  }
  .data-summary-top .flex {
    margin: 20px 10px !important;
  }
  .bigText {
    font-size: 18px;
  }
}
</style>

